import script from "./Update.vue?vue&type=script&setup=true&lang=js"
export * from "./Update.vue?vue&type=script&setup=true&lang=js"

import "./Update.vue?vue&type=style&index=0&id=0e5627fe&lang=scss&scoped=true"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/Users/uguraslan/work/ljs/tools/strike/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e5627fe"]])

export default __exports__